import { NextResponse } from "next/server"
import {
  buildAdminAjaxUrl,
  resolveWordPressOrigin,
  type ValidateTriiboOtpInput,
  type ValidateTriiboOtpResponse,
} from "@/api/auth"
import { env } from "@/env"
import {
  decodeWordPressLoggedInCookie,
  postAdminAjax,
} from "@/services/wordpress-service"
import { setSession } from "~/services/auth-service"
import { getWooCommerceCustomer } from "~/services/woo-commerce-service"

const toUrlEncodedBody = (input: Record<string, string>): URLSearchParams => {
  const payload = new URLSearchParams()

  for (const [key, value] of Object.entries(input)) {
    payload.set(key, value)
  }

  return payload
}

const PHONE_PREFIX_REGEX = /^\+/

const isLoggedInValue = (value: unknown): boolean => {
  return value === true || value === "true" || value === 1 || value === "1"
}

export const POST = async (request: Request) => {
  const body = (await request.json()) as ValidateTriiboOtpInput
  const origin = resolveWordPressOrigin(env.WP_API_URL)
  const endpoint = buildAdminAjaxUrl(origin)

  try {
    const cleanCellphone = body.cellphone.replace(PHONE_PREFIX_REGEX, "")

    const { data, cookies } = await postAdminAjax(
      endpoint,
      toUrlEncodedBody({
        action: "tal_validate_sms",
        code: body.code,
        cellphone: cleanCellphone,
        trans_id: body.transactionId,
        ckt: `${body.ckt ?? false}`,
      })
    )

    const response = data as ValidateTriiboOtpResponse
    const sessionCookie = cookies?.trim() || null

    if (response.success) {
      const isLoggedIn =
        isLoggedInValue(response.data?.logged_in) ||
        response.data?.status === "user_found_and_logged_in"

      if (isLoggedIn && !sessionCookie) {
        return NextResponse.json(
          {
            success: false,
            error: {
              errorCode: "AUTH_COOKIE_MISSING",
              message: "Nao foi possivel criar sessao autenticada.",
            },
          },
          { status: 502 }
        )
      }

      if (isLoggedIn && sessionCookie) {
        const wpUser = decodeWordPressLoggedInCookie(sessionCookie)
        const customer = wpUser
          ? await getWooCommerceCustomer(wpUser.username)
          : null

        let sessionUser: { id: string | number; name: string; email: string }

        if (customer) {
          sessionUser = {
            id: customer.id,
            name: customer.name,
            email: customer.email,
          }
        } else if (wpUser) {
          sessionUser = {
            id: wpUser.username,
            name: wpUser.username.split("@")[0] ?? "Cliente",
            email: wpUser.username,
          }
        } else {
          sessionUser = {
            id: body.cellphone.replace(/\D/g, ""),
            name: "Cliente",
            email: "",
          }
        }

        await setSession({
          wordpressSessionCookie: sessionCookie,
          user: sessionUser,
        })
      }

      return NextResponse.json({ ...response, redirect: "/" })
    }

    return NextResponse.json(response)
  } catch (error) {
    const message =
      error instanceof Error ? error.message : "Falha ao validar codigo OTP."

    return NextResponse.json(
      { success: false, error: { errorCode: 500, message } },
      { status: 500 }
    )
  }
}
